import { AlmeAppUtilsBase } from './../../components/AlmeApp/AlmeAppState';
export class MessageHandlerBase extends AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
    }
    sendAppEvent(message, appEvent) {
        const apiParams = this.createApiParams(message);
        this.apiUtils.sendAppEvent(appEvent, "External", apiParams)
            .then(this.onAppEventSuccess.bind(this), this.onAppEventFailure.bind(this));
    }
    createApiParams(message) {
        const appParameters = {};
        appParameters.ClientSessionId = this.almeState.clientSessionId;
        appParameters.IsLoggedIn = this.almeState.isLoggedIn;
        if (message.userData) {
            const userData = Object.assign({}, message.userData);
            if (userData.pageName) {
                appParameters.pageName = userData.pageName;
                delete userData.pageName;
            }
            // Account Id in platform message comes as number
            if (userData.accountId) {
                userData.accountId = `${userData.accountId}`;
            }
            if (Object.keys(userData).length >= 1) {
                appParameters.UserObj = userData;
            }
        }
        return appParameters;
    }
    onAppEventSuccess(appEventResponse) {
        if (appEventResponse) {
            const responseEntryId = appEventResponse.extensionData.entryId;
            this.almeState.history.push(appEventResponse);
            this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { lastEntryId: responseEntryId, chatId: appEventResponse.extensionData.chatId, lastActivityTime: Date.now() }));
        }
    }
    onAppEventFailure(error) {
        console.error(error);
    }
}
